import { gql, useQuery } from "@apollo/client";

export const Machines = gql`
	query machines($term: String, $limit: Int, $offSet: Float) {
		machines(input: { term: $term, limit: $limit, offSet: $offSet }) {
			data {
				_id
				name
				photo
				items
				itemsInfo {
					_id
					name
					ref
					count
					brand
				}
				status
				ref
			}
			
			paginantionInfo {
				numberDocuments
				currentSkip
			}
		}
	}
`;

export const GetMachineDocumentsExpiration = gql`
  query machineDocumentsExpiration {
    machineDocumentsExpiration {
      _id
      photo
      name
      serialNumber
      category
      items
      documentsInfo {
        public
        expirationDate
      }
      status
      pin
      ref
    }
  }
`;

export const GetExpiringMachines = gql`
  query GetMachineRentingExpiration($hoursThreshold: Int) {
    getMachineRentingExpiration(hoursThreshold: $hoursThreshold) {
      _id
      name
      ref
      status
      photo
      category
    }
  }
`;
